/**
 * Company: SPHMedia
 * Description: [Portrait video package component for homepage story packages]
 */

import InlineVideoPlayer from "@elements/Player/InlineVideoPlayer";
import useShortFormVideo from "@hooks/useBrightcoveVideo/useShortFormVideo";
import type { LatestVideoResponse } from "@typings/Brightcove.d";
import { ReactElement, useRef, useState } from "react";

import MediaCard from "./MediaCard";
import { MediaVariant } from "./types/MediaVariant.d";

/**
 * PortraitVideoPackage
 * Description: [Portrait video package component for homepage story packages]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function PortraitVideoPackage(): ReactElement {
  const portraitVideoParentRef = useRef<HTMLDivElement>(null);
  const playerRef = useRef<HTMLDivElement>(null);
  const pipContainerRef = useRef<HTMLDivElement>(null);

  const [isSticky, setIsSticky] = useState<boolean>(false);
  const [isMute, setIsMute] = useState<boolean>(true);

  const { playing, videos, handleOnClickThumbnail, handleOnEndedVideo } =
    useShortFormVideo({
      parentRef: portraitVideoParentRef,
      limit: 10,
    });

  return (
    <>
      <div
        ref={pipContainerRef}
        className={`fixed bottom-4 right-4 z-50
          ${isSticky ? "block w-[300px]" : "hidden"}`}
      />

      <div
        ref={portraitVideoParentRef}
        className="w-full"
        id="portrait-video-package"
      >
        {videos.length > 0 && (
          <MediaCard<LatestVideoResponse>
            variant={MediaVariant.RINGKAS}
            renderedThumbnail={videos}
            handleOnClickCallback={(source) => {
              const video = videos.find((item) => item.id === source);

              if (video) {
                handleOnClickThumbnail(video);
              }
            }}
            activeItemId={playing?.id}
            renderThumbnail={(item, _, defaultThumbnail) => {
              if (playing?.id !== item.id) {
                return defaultThumbnail;
              }

              return (
                <InlineVideoPlayer
                  playing={item}
                  forwardedRef={playerRef}
                  onEnded={handleOnEndedVideo}
                  nextPlaylist={handleOnEndedVideo}
                  isSticky={isSticky}
                  setIsSticky={setIsSticky}
                  observerRef={portraitVideoParentRef}
                  pipContainerRef={pipContainerRef}
                  syncMuteAcrossPlayers={false}
                  isMute={isMute}
                  setIsMute={setIsMute}
                />
              );
            }}
          />
        )}
      </div>
    </>
  );
}
